import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { socialSatausConfig, taxDeductionConfig, bankConfig, accumulationFundEnum, welfareFundEnum } from '../config.js';
import { sysInfoFn } from '@/api/org/per';
export default {
  components: {},
  props: {
    staffInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      socialSatausConfig: socialSatausConfig,
      taxDeductionConfig: taxDeductionConfig,
      accumulationFundEnum: accumulationFundEnum,
      welfareFundEnum: welfareFundEnum,
      bankConfig: bankConfig,
      min: 10,
      max: 10,
      sysInfo: {}
    };
  },
  created: function created() {
    this.getSysInfoFn();
  },
  methods: {
    getSysInfoFn: function getSysInfoFn() {
      var _this = this;
      sysInfoFn().then(function (res) {
        if (res && res.code === 1) {
          _this.sysInfo = res.data;
        }
      });
    },
    changeTaxDeduction: function changeTaxDeduction(item) {
      this.$emit('changeTax', item);
    },
    bankChange: function bankChange(val) {
      var item = this.bankConfig.find(function (i) {
        return i.value === val;
      });
      if (!item) return;
      this.min = item.minLength;
      this.max = item.maxLength ? item.maxLength : item.minLength;
      this.$emit('bankChange', this.min, this.max);
    },
    taxIdBlur: function taxIdBlur(val) {
      this.$emit('taxIdBlur', val);
    }
  },
  watch: {
    'staffInfo.bank_name': {
      handler: function handler(val) {
        this.bankChange(val);
      },
      deep: true,
      immediate: true
    }
  }
};